import { render, staticRenderFns } from "./SignPayrollModal.vue?vue&type=template&id=67674f1e&scoped=true&"
import script from "./SignPayrollModal.vue?vue&type=script&lang=js&"
export * from "./SignPayrollModal.vue?vue&type=script&lang=js&"
import style0 from "./SignPayrollModal.vue?vue&type=style&index=0&id=67674f1e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67674f1e",
  null
  
)

export default component.exports